module.exports = __webpack_public_path__ + "img/VRfprSDGs-1110x450.1e18c593.png";